{
  "styles": {
    "models": {
      "resetHeight": "Reset height",
      "resetLength": "Reset length",
      "resetWidth": "Reset width",
      "attributeModel": "Edit your 3D model by changing the model and the dimensions",
      "attributeDimensions": "Edit your 3D model by changing the dimensions",
      "determineModel": "Determine model by",
      "determineDimensions": "Determine length, width and height by"
    }
  },
  "exports": {
    "legendPosition": "Legend position",
    "top": "Top",
    "bottom": "Bottom",
    "left": "Left",
    "right": "Right",
    "layers": "Layers",
    "all": "All",
    "custom": "Custom",
    "selectLayers": "Select layers to export",
    "selected": "selected",
    "hidden": "(Hidden)",
    "none": "None"
  },
  "get_map_errors": {
    "default": "Something went wrong",
    "not_found": "Plan not found",
    "click_here_to_browser_maps": "Click here to browse plans"
  },
  "add_list_item_attribute": {
    "title": "Add column",
    "subtitle": "Edit this attribute to your requirements by using the fields below",
    "column_name": "Column name",
    "column_type": "Column type",
    "type": "Property type"
  },
  "list_item_properties": {
    "additional_properties": "Additional properties"
  },
  "contextMenu": {
    "import": "Import",
    "export": "Export",
    "copy_layer": "Copy layer{{ pluralise }}",
    "copy_group": "Copy group{{ pluralise }}",
    "copy_layer_and_group": "Copy layer{{ pluraliseLayers }} and group{{ pluraliseGroups }}",
    "delete": "Delete",
    "delete_layers_title": "Deleting layers",
    "delete_layers_description": "One or more of the layers you are trying to delete are linked to another map. They are being removed from this map and you can relink them at any time."
  },
  "copyOrUnlinkLayers": {
    "copy": "Copy",
    "unlink": "Unlink",
    "copying_layers": "Copying layers",
    "unlink_layer": "Unlink a layer",
    "linked_layers": "Linked layers",
    "original_plan": "Original plan",
    "helpbase_blurb": {
      "click": "Click here",
      "link": "Getting started - Knowledge Base (iventis.com)",
      "further_info": "for further information."
    },
    "copy_blurb": {
      "are_you_sure": "Are you sure you want to copy",
      "this": "this",
      "these": "these",
      "layer": "layer{{ pluralise }}",
      "group": "group{{ pluralise }}",
      "layers_and_groups": "layers and groups"
    },
    "unlink_info": {
      "links_to": "This layer links to",
      "changes_not_reflected": "By unlinking from it's original plan, you are creating a copy. Any changes made to the original layer will no longer be reflected in your plan."
    },
    "unlink_blurb": "You are copying layers linked to different maps. By unlinking from it's original plan, you are creating a copy. Any changes made to the original layer will no longer be reflected in your plan.",
    "copy_with_map_objects": "Copy layer{{ pluralise }} with map objects"
  },
  "shareMap": {
    "title": "Share plan",
    "share_with_team": "Share with team",
    "share_with_team_details": "Share the plan with team members by moving it into 'Team Workspace'",
    "shared_library": {
      "title": "Share file with team",
      "footer": "Team members can view the file as read-only"
    },
    "shared_link": {
      "title": "Share Link"
    },
    "share_link": "Generate link",
    "share_link_details": "Create a temporary, read-only link to share this plan with users who don't have access to Iventis",
    "share_link_generated": "This link will expire in {{ numberOfDays }} days. You can generate a new link at any time."
  },
  "defaultAttribute": {
    "add": "Add a default value for attribute",
    "default_field_type": "Default {{ dataFieldType }} value",
    "tickbox": {
      "label": "Default tick box state",
      "on": "ON",
      "off": "OFF"
    }
  },
  "fileUpload": {
    "import_title": "Import data to map",
    "drop_file": "Drop file to upload",
    "supported_extensions": "Supported extensions",
    "contact_support": "Contact support for larger files and other extensions",
    "choose_file": "Choose file",
    "max_file_size": "Maximum file size {{ maxFileSize }}MB"
  }
}